import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction } from '@/api/manage';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: "AssetOmLogModal",
  data: function data() {
    return {
      title: '资产运维台账详细',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: "center"
      }, {
        dataIndex: 'productName',
        title: '产品名称',
        align: "center"
      }, {
        dataIndex: 'productCode',
        title: '产品编号',
        align: "center"
      }, {
        dataIndex: 'productCategory_dictText',
        title: '产品类型',
        align: "center"
      }, {
        dataIndex: 'productUnit_dictText',
        title: '计量单位',
        align: "center"
      }, {
        dataIndex: 'quantity',
        title: '数量',
        align: "center"
      }, {
        dataIndex: 'purpose_dictText',
        title: '用途',
        align: "center"
      }, {
        dataIndex: 'eventType_dictText',
        title: '事件类型',
        align: "center"
      }, {
        dataIndex: 'createBy_userName',
        title: '操作人',
        align: "center"
      }, {
        dataIndex: 'createTime',
        title: '操作时间',
        align: "center"
      }],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },

      /* table加载状态 */
      loading: false,
      queryParam: {},
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      visible: false,
      dates: {},
      userTree: [],
      //人员信息
      autoLoadInit: false,
      itemList: {}
    };
  },
  created: function created() {
    this.queryUserTreeList();
  },
  methods: {
    onOperationDateDate: function onOperationDateDate(value, dateArray) {
      this.queryParam.dateStart = dateArray[0];
      this.queryParam.dateEnd = dateArray[1];
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    show: function show(record) {
      this.visible = true;
      this.itemList = record;
      this.queryParam.productCategory = this.itemList.productCategory;
      this.queryParam.siteId = this.itemList.siteId;
      this.queryParam.productId = this.itemList.productId;
      this.queryParam.purpose = this.itemList.purpose;
      this.queryParam.purposeId = this.itemList.purposeId;
      this.initTableData();
    },
    initTableData: function initTableData(arg) {
      var _this2 = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction("/ea/asset/om/log/itemList", params).then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result.records;
          _this2.ipagination.total = res.result.total;
          _this2.loadNums++;
        } else {
          _this2.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this2.loading = false;

        if (_this2.$refs.page) {
          _this2.$refs.page.disabled = false;
        }
      });
    },
    getQueryParams: function getQueryParams() {
      //获取查询条件
      var sqp = {};
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters);
      param.field = this.getQueryField();
      param.current = this.queryParam.current || this.ipagination.current;
      param.size = this.queryParam.size || this.ipagination.pageSize;
      param.searchCount = this.searchCount;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      //TODO 字段权限控制
      var str = 'id,';
      this.columns.forEach(function (value) {
        if (value.dataIndex) {
          str += ',' + value.dataIndex;
        }
      });
      return str;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    loadData: function loadData(arg) {
      this.initTableData(arg);
    },
    searchReset: function searchReset() {
      var that = this;
      this.queryParam = {};
      this.queryParam.productCategory = this.itemList.productCategory;
      this.queryParam.siteId = this.itemList.siteId;
      this.queryParam.productId = this.itemList.productId;
      this.queryParam.purpose = this.itemList.purpose;
      this.queryParam.purposeId = this.itemList.purposeId;
      that.loadData(1);
    }
  }
};